import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingInnovationRoot = styled("section")<{
  $bg?: {
    desktop?: string;
    mobile?: string;
  };
  $linkColor?: string;
}>(({ $linkColor }) => {
  return css`
    padding: 48px 0px;

    @media ${responsiveMap.mobile} {
      padding: 48px 0px;
    }

    .landing-innovations {
      &__container {
        display: flex;
        flex-direction: column;
        gap: 48px;
        align-items: center;
        @media ${responsiveMap.mobile} {
          gap: 24px;
        }
        &.chef-2024 {
          padding: 72px 48px 75px;
          @media ${responsiveMap.mobile} {
            padding: 24px 16px;
          }
        }
      }
      &__header {
        max-width: 518px;
        gap: 13px;
        @media ${responsiveMap.mobile} {
          gap: 8px;
          padding: 0px 16px;
        }
      }

      &__description a {
        color: ${$linkColor || "inherit"};
        text-decoration: underline;
      }

      &__cover {
        position: relative;
        width: 100%;
        aspect-ratio: 3 / 1;
        overflow: hidden;
        @media ${responsiveMap.mobile} {
          display: none;
        }
      }
    }
  `;
});

export const _LandingInnovationCarouselSection = styled("div")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const _LandingInnovationProductList = styled("div")<{
  $isList?: boolean;
  $itemFullWidth?: boolean;
}>(({ $isList, $itemFullWidth }) => {
  if ($isList) {
    return {
      width: "100%",
      [".innovation-product-item"]: {
        minWidth: 324,
        width: 324,
      },

      ".innovation-product-list-wrapper": {
        display: "flex",
        flexWrap: "wrap",
        rowGap: 24,
        columnGap: 48,
        width: "100%",
        justifyContent: "center",
        [`@media ${responsiveMap.mobile}`]: {
          display: "grid",
          gridTemplateColumns: "repeat(1, 1fr)",
          gridTemplateRows: "unset",
          width: "unset",
          rowGap: 48,
          ".break": {
            display: "none",
          },
        },
      },
    };
  }
  return {
    overflow: "hidden",
    overflowX: "auto",
    msOverflowStyle: "none", // IE & MS Edge
    scrollbarWidth: "none", // Firefox
    scrollSnapType: "x mandatory",
    width: "100%",
    ["&::-webkit-scrollbar"]: { display: "none" }, // Chrome, Safari and Opera
    [".innovation-product-item"]: {
      scrollSnapAlign: "start",
      minWidth: 285,
      width: $itemFullWidth ? undefined : 285,
      flex: $itemFullWidth ? 1 : undefined,
    },

    ".innovation-product-list-wrapper": {
      width: "100%",
      gap: 8,
      [`@media ${responsiveMap.mobile}`]: {
        padding: "0 16px",
      },
    },
  };
});

export const _Chef2024Left = styled("div")(() => ({}));
export const _Chef2024Right = styled("div")(() => ({}));
export const _Chef2024RightWrapper = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gridTemplateRows: "repeat(3, 0fr)",
  rowGap: 16,
  columnGap: 16,
  ".top-content": {
    gridArea: "1 / 1 / 2 / 3",
  },
}));

export const _MosaiqueGrid = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 16,
  width: "100%",
  margin: "0 auto",
  padding: "0 48px",
  [".innovation-product-item"]: {
    height: "100%",
  },
  [`@media ${responsiveMap.mobile}`]: {
    gridTemplateColumns: "repeat(2, 1fr)",
    padding: "0 16px",
  },
}));

export const _Chef2024Container = styled("div")<{}>(() => {
  return {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    [_Chef2024Left]: {
      width: "calc(33.33333% - 10.66667px)",
      display: "grid",
      gridTemplateColumns: "repeat(1,1fr)",
      gridTemplateRows: "repeat(2,0fr)",
      rowGap: 16,
      columnGap: 16,
    },
    [_Chef2024Right]: {
      flex: 2,
      width: "calc(66.66667% - 21.33333px)",
    },
  };
});
